import { render } from "./NewUpdateForm.vue?vue&type=template&id=305e5b8c&scoped=true"
import script from "./NewUpdateForm.vue?vue&type=script&lang=js"
export * from "./NewUpdateForm.vue?vue&type=script&lang=js"

import "../styles/UpdateProfile.scss?vue&type=style&index=0&id=305e5b8c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305e5b8c"]])

export default __exports__